import { FC } from "react";

import { AnimatedFadeSwitch } from "@ryde/layout";

import { RidesViewSwitchPane } from "./rides-view-switch-pane";
import { useRidesKanbanSwitchRoutes } from "./use-rides-kanban-switch-routes";

export const RidesKanbanSwitchRoutes: FC = () => {
  const { location, navigateToSegment, viewSwitchKey } =
    useRidesKanbanSwitchRoutes();

  return (
    <AnimatedFadeSwitch switchKey={viewSwitchKey}>
      <RidesViewSwitchPane
        key={viewSwitchKey}
        location={location}
        navigateToSegment={navigateToSegment}
        paneViewKey={viewSwitchKey}
      />
    </AnimatedFadeSwitch>
  );
};
